module.exports = __webpack_public_path__ + "static/fraz_urbluu-eb195d120806ea42abae26bf82f448e3.png";